import React, { Component } from "react";
import { Link } from "react-router-dom";
import AppContext from "../../../contexts/AppContext";

export class StartTrialButton extends Component {   
    
    constructor(props) {
        super(props);        
    }
	
	render() {
        return (            
            <button onClick={this.props.HandleScrollToStats} className={this.props.clsName}>
                <h4 className="text-white mb-2">{this.props.title}</h4>
                <p>Start finding writing jobs right now!</p>
                <img className="w-auto position-absolute" src="images/Icon feather-arrow-right.png" alt="Icon feather-arrow-right" loading="lazy" srcSet="images/Icon feather-arrow-right.png 1x, images/Icon feather-arrow-right@2x.png 2x"/>
            </button>
		);
        
    }
}

StartTrialButton.contextType = AppContext;
export default StartTrialButton;


// WEBPACK FOOTER //
// ./src/components/general/include/StartTrialButton.js